import { REPORT_ACTIONS } from "../actions/ReportActions";

let initialState = {
  loading: true,
  reportPopupDialog: false,
};

const reportReducer = (state = initialState, action) => {
  const { type, values } = action;
  switch (type) {
    case REPORT_ACTIONS.SET_LOADING:
      return { ...state, loading: values.loading };
    case REPORT_ACTIONS.TOGGLE_REPORT_POPUP:
      return { ...state, reportPopupDialog: values.reportPopupDialog };
    default:
      break;
  }
  return state;
};

export default reportReducer;
